import React, { useContext } from "react";
import { NavigateFunction } from "react-router-dom";
import { refreshTokenCALL } from "../services/authService";
import storage from "./storage";
import { MyContext } from "MyProvider";

/**
 * Handling Snackbar closing
 *
 * @param {*} setshowSnackBar
 */
export const handleSnackbarClose = (setshowSnackBar: any) => {
    setshowSnackBar({
        show: false,
        message: "",
        severity: ""
    })
}

/**
   * Masking Email
   *
   * @param {string} [email='']
   * @returns {string}
   */
export const maskEmail = (email = '') => {
    return email.replace(/^(.)(.*)(.@.*)$/,
        (_, a, b, c) => a + b.replace(/./g, '*') + c)
};

/**
 * Calling List API as per modules
 *
 * @param {React.Dispatch<React.SetStateAction<boolean>>} setLoading
 * @param {() => Promise<any>} method
 * @param {React.Dispatch<React.SetStateAction<never[]>>} setData
 * @param {*} setshowSnackBar
 * @returns {any, setData: any, setshowSnackBar: any) => void}
 */
export const GetEntitiesList = (setLoading: React.Dispatch<React.SetStateAction<boolean>>, method: (ar1: any) => Promise<any>,
    setData: React.Dispatch<React.SetStateAction<never[]>>, setshowSnackBar: any, params?: any) => {
    setLoading(true);

    method(serialize(params)).then((response: any) => {
        setLoading(false);
        if (response.results && response.results.length > 0) {
            
            setData(response.results);
        }

    }).catch((error: any) => {
        setLoading(false);
        setshowSnackBar({
            show: true,
            message: error.response.data.message,
            severity: 'error'
        });
    })
}


/**
 * Add Entity by calling this method
 *
 * @param {React.Dispatch<React.SetStateAction<boolean>>} setLoading
 * @param {(arg1: any) => Promise<any>} method
 * @param {*} values
 * @param {*} setshowSnackBar
 * @param {string} successMsg
 * @param {string} redirectLink
 * @param {NavigateFunction} navigate
 * @returns {any, values: any, setshowSnackBar: any, successMsg: string, redirectLink: string) => void}
 */
export const AddEntitiyMethod = (setLoading: React.Dispatch<React.SetStateAction<boolean>>, method: (arg1: any) => Promise<any>,
    values: any, setshowSnackBar: any, successMsg: string, redirectLink: string, navigate: NavigateFunction) => {
    setLoading(true);
    method(values).then(response => {
        setshowSnackBar({
            show: true,
            message: successMsg,
            severity: 'success'
        });
        setTimeout(() => {
            setLoading(false);
            navigate(redirectLink)
        }, 400);
    }).catch(error => {
        setLoading(false);
        setshowSnackBar({
            show: true,
            message: error.response.data.message,
            severity: 'error'
        });
    })
}

/**
 * Edit Entity by calling this method
 *
 * @param {React.Dispatch<React.SetStateAction<boolean>>} setLoading
 * @param {(arg1: any, arg2: any) => Promise<any>} method
 * @param {string} id
 * @param {*} values
 * @param {*} setshowSnackBar
 * @param {string} successMsg
 * @param {string} redirectLink
 * @param {NavigateFunction} navigate
 * @returns {any, id: string, values: any, setshowSnackBar: any, successMsg: string, redirectLink: string) => void}
 */
export const EditEntitiyMethod = (setLoading: React.Dispatch<React.SetStateAction<boolean>>, method: (arg1: any, arg2: any) => Promise<any>, id: string,
    values: any, setshowSnackBar: any, successMsg: string, redirectLink: string, navigate: NavigateFunction) => {
    setLoading(true);
    method(id, values).then(response => {
        setshowSnackBar({
            show: true,
            message: successMsg,
            severity: 'success'
        });
        setTimeout(() => {
            setLoading(false);
            navigate(redirectLink)
        }, 400);
    }).catch(error => {
        setLoading(false);
        setshowSnackBar({
            show: true,
            message: error.response.data.message,
            severity: 'error'
        });
    })
}


/**
 * Get Entity details by ID
 *
 * @param {React.Dispatch<React.SetStateAction<boolean>>} setLoading
 * @param {(arg1: any) => Promise<any>} method
 * @param {string} id
 * @param {*} setData
 * @param {*} setshowSnackBar
 * @returns {any, id: string, setData: any, setshowSnackBar: any) => void}
 */
export const GetEntitiyByIDMethod = (setLoading: React.Dispatch<React.SetStateAction<boolean>>, method: (arg1: any) => Promise<any>, id: string,
    setData: any, setshowSnackBar: any) => {
    setLoading(true);
    method(id ? id : '').then(response => {
        setLoading(false);
        if (response.data) {
            setData(response.data)
        } else {
            setData(response)
        }
    }).catch(error => {
        setLoading(false);
        setshowSnackBar({
            show: true,
            message: error.response.data.message,
            severity: 'error'
        });
    })
}

export const setAutoFocus = () => {
    let content: any = document.getElementsByTagName('form')[0].querySelector('input');
    if (content)
        content.focus();
}

export const RefreshTokenAPI = (setAddSecondaryUser) => {

    const refreshTokenData = storage.getRefreshToken();
   
    refreshTokenCALL({ 'refreshToken': refreshTokenData }).then(response => {
       setAddSecondaryUser(response.data.user.add_secondary_user)
        storage.setToken(response.data.tokens.access.token);
        storage.setRefreshToken(response.data.tokens.refresh.token);
        storage.setData('user-info', response.data.user);
        storage.setData('refresh-token', response.data.tokens.refresh);
    }).catch(error => {
        // console.log("Invalid Session");
    })
}


/**
 * Converting Object to Query Param
 *
 * @param {*} obj
 * @returns {*}
 */
export const serialize = (obj: any) => {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}
